export default __webpack_public_path__ + "static/media/3X4A1409 (1)_tn.f541dd01.jpg";